module.exports = __webpack_public_path__ + "static/webheader-01-b8af24cde635ca1069f743acde786a41.png";